import { Link } from 'react-router-dom';
import '../index.css';

const Product2 = () => {
  return (
    <div className="product-detail-page">
      <header className="products-header">
        <div className="section-inner">
          <Link to="/produtos" className="back-button">
            ← Voltar para Produtos
          </Link>
          <h1 className="products-title">Créditos Direto na Sua Conta Lovable</h1>
          <p className="products-subtitle">Receba créditos diretamente na sua conta Lovable</p>
        </div>
      </header>

      <section className="coming-soon-section">
        <div className="section-inner">
          <div className="coming-soon-box">
            <img src="https://static.lumi.new/20/2060299bbd3e43532341649d9d9976c5.webp" alt="Créditos Direto na Sua Conta Lovable" style={{ width: '100%', maxWidth: 420, borderRadius: 16, marginBottom: 24 }} />
            <h2>Créditos Direto na Sua Conta Lovable</h2>
            <p>Estamos trabalhando em algo incrível para você!</p>
            <Link to="/produtos" className="cta-button-primary">
              Ver Todos os Produtos
            </Link>
          </div>
        </div>
      </section>

      <footer className="site-footer">
        <div className="section-inner">
          <div className="footer-brand">
            <img src="https://static.lumi.new/00/0011bb058a2686e447915d0083474f56.webp" alt="Mestre Lovable Infinity" className="footer-logo" />
            <span className="footer-name">Extensão Lovable Ilimitado</span>
          </div>
          <p className="footer-copy">&copy; 2026 Mestre do Lovable - Todos os direitos reservados</p>
        </div>
      </footer>
    </div>
  );
};

export default Product2;
